<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dYfu13/images/9780316216678.jpg?1733067555069" alt="This image is the cover for the book Ordeal of Gilbert Pinfold"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ordeal of Gilbert Pinfold
      </h1>
      <p class="bookDescription body article font2">
        <b>"The very model of the modern paranoid novel" (<i>New York Times</i>) and an ambitious work of semi-autobiographical fiction from one of England's greatest novelists. </b><br/><br/>Gilbert Pinfold is a reclusive Catholic novelist suffering from acute inertia. In an attempt to defeat insomnia he has been imbibing an unappetizing cocktail of bromide, chloral, and creme de menthe. He books a passage on the SS <i>Caliban </i>and, as it cruises towards Ceylon, rapidly slips into madness.<br/><br/>Almost as soon as the gangplank lifts, Pinfold hears sounds coming out of the ceiling of his cabin: wild jazz bands, barking dogs, and loud revival meetings. He is convinced that an erratic public-address system is letting him hear everything that goes on aboard ship . . . until instead of just sounds he hears voices. And not just any voices. These voices are talking, in the most frighteningly intimate way, about him!<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Evelyn Waugh
      </h2>
      
      <p class="authorDescription body article">&amp;lt;DIV&amp;gt;Evelyn Waugh (1903-1966), whom &amp;lt;I&amp;gt;Time&amp;lt;/I&amp;gt; called "one of the century's great masters of English prose," wrote several widely acclaimed novels as well as volumes of biography, memoir, travel writing, and journalism. Three of his novels, &amp;lt;I&amp;gt;A Handful of Dust, Scoop, &amp;lt;/I&amp;gt;and&amp;lt;I&amp;gt; Brideshead Revisited,&amp;lt;/I&amp;gt; were selected by the Modern Library as among the 100 best novels of the twentieth century.&amp;lt;/DIV&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Little, Brown and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d41c79ba